import React, { useState, useEffect, useRef } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import {
  getCancelledOrders,
  getCancelledSI,
} from "../../Helpers/apiCalls/reportsAPI";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import Table from "../../Components/TableTemplate/Table";
import {
  dateFormat,
  formatDate,
  getRole,
  numberFormat,
  toastStyle,
  refreshPage,
  numberWithCommas,
  // getRestoLogin,
} from "../../Helpers/Utils/Common";
import ExportPDF from "../../Components/Export/ExportPDF";
import { useReactToPrint } from "react-to-print";
import Pdf from "react-to-pdf";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Moment from "moment";
import moment from "moment";
import imageCompression from "compressorjs";
import html2canvas from "html2canvas";
import toast from "react-hot-toast";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";
import MytFooter from "../../Components/MytFooter";
const ref = React.createRef();
const ref2 = React.createRef();

function CancelledSI() {
  const [inactive, setInactive] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const componentRef = useRef();
  const componentRefSI = useRef();

  ///////////

  const [chooseExportCSV, setChooseExportCSV] = useState("Cancelled SI");
  const [readyExportSI, setReadyExportSI] = useState(false);

  const [pdfCancelledOrders, setPdfCancelledOrders] = useState([]);
  const [pdfCancelledSI, setPdfCancelledSI] = useState([]);
  const [cancelledOrders, setCancelledOrders] = useState([]);
  const [cancelledSI, setCancelledSI] = useState([]);

  const [subtotal, setSubtotal] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [vatSales, setVatSales] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [vatExempt, setVatExempt] = useState(0);
  const [vatExemption, setVatExemption] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [zeroRated, setZeroRated] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  });
  const [filterSI, setFilterSI] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  });

  const headerSI = [
    "Invoice No.",
    "Added On",
    "Cancelled On",
    "Approved By",
    "Subtotal",
    "Vat Sales",
    "Vat Exempt Sales",
    "Zero Rated",
    "Total Sales",
    "Total Vat",
    "Total Discount",
    "Vat Exemption",
    "Total Amount",
  ];

  async function fetchCancelledOrders() {
    setShowLoader(true);
    const response = await UseGetRequest(
      "reports/cancelledOrders",
      { ...filter, type: "cancelled" },
      // getRestoLogin()
    );
    if (response.data) {
      let result = [];
      result = response.data.data.cancelled_orders.map((data) => {
        return {
          id: data.id,
          added_on:
            data.added_on !== "0000-00-00"
              ? Moment(data.added_on).format("MMM DD, YYYY")
              : "",
          updated_on:
            data.updated_on !== "0000-00-00"
              ? Moment(data.added_on).format("MMM DD, YYYY")
              : "",
          attendant: data.attendant,
          approved_by: data.approved_by,
          grand_total: data.grand_total,
        };
      });
      setCancelledOrders(result);
      setPdfCancelledOrders(result);
    }
    setShowLoader(false);
  }

  async function fetchCancelledSI() {
    setShowLoader(true);
    const response = await UseGetRequest(
      "reports/cancelledSI",
      filterSI,
      // getRestoLogin()
    );
    if (response.data) {
      let result = [];
      result = response.data.data.cancelled_sis.map((data) => {
        return {
          id: data.id,
          added_on:
            data.added_on !== "0000-00-00"
              ? Moment(data.added_on).format("MMM DD, YYYY")
              : "",
          updated_on:
            data.updated_on !== "0000-00-00"
              ? Moment(data.added_on).format("MMM DD, YYYY")
              : "",
          approved_by: data.approved_by,
          total_amount: data.total_amount,
          discount: data.discount,
          trans_id: data.id,
          order_id: data.order_id,
          subtotal: data.subtotal,
          total_sales: data.total_sales,
          vat_sales: data.vat_sales,
          vat_amount: data.vat_amount,
          vat_exempt: data.vat_exempt,
          vat_exemption: data.vat_exemption,
          zero_rated: data.zero_rated,
        };
      });
      result = response.data.data.cancelled_sis.map((data) => {
        return {
          id: data.id,
          added_on:
            data.added_on !== "0000-00-00"
              ? Moment(data.added_on).format("MMM DD, YYYY")
              : "",
          updated_on:
            data.updated_on !== "0000-00-00"
              ? Moment(data.added_on).format("MMM DD, YYYY")
              : "",
          approved_by: data.approved_by,
          subtotal: data.subtotal,
          vat_sales: data.vat_sales,
          vat_exempt: data.vat_exempt,
          zero_rated: data.zero_rated,
          total_sales: data.total_sales,
          vat_amount: data.vat_amount,
          discount: data.discount,
          vat_exemption: data.vat_exemption,
          total_amount: data.total_amount,
          trans_id: data.id,
          order_id: data.order_id,
        };
      });
      setCancelledSI(result);
      setPdfCancelledSI(result);
      setReadyExportSI(true);
      setSubtotal(
        result
          .map((data) => parseFloat(data.subtotal))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setTotalSales(
        result
          .map((data) => parseFloat(data.total_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setVatSales(
        result
          .map((data) => parseFloat(data.vat_sales))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setVatAmount(
        result
          .map((data) => parseFloat(data.vat_amount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setVatExempt(
        result
          .map((data) => parseFloat(data.vat_exempt))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setVatExemption(
        result
          .map((data) => parseFloat(data.vat_exemption))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setDiscount(
        result
          .map((data) => parseFloat(data.discount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setZeroRated(
        result
          .map((data) => parseFloat(data.zero_rated))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
      setTotalAmount(
        result
          .map((data) => parseFloat(data.total_amount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );
    }
    setShowLoader(false);
  }

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  const handleFilterSI = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filterSI };
    filtercopy[name] = value;
    setFilterSI(filtercopy);
  };

  /** EXPORT */
  function handleToCSV() {
    // if (readyExport) {
    return (
      <DownloadTableExcel
        filename="Cancelled Orders Report"
        sheet="users"
        currentTableRef={componentRef.current}
      >
        <button className="category-new-export-btn">Export to CSV</button>
      </DownloadTableExcel>
    );
    // }
  }

  function handleToCSVSI() {
    // if (readyExportSI) {
    return (
      <DownloadTableExcel
        filename="Cancelled Invoice Report"
        sheet="users"
        currentTableRef={componentRefSI.current}
      >
        <button className="category-new-export-btn">Export to CSV</button>
      </DownloadTableExcel>
    );
    // }
  }
  const componentRefSummarySI = useRef();
  const handlePrintReportSI = useReactToPrint({
    content: () => componentRefSummarySI.current,
    pageStyle: () => "@page { size: letter; margin: 5mm; }",
  });

  function handlePDF() {
    return (
      <ExportPDF
        name={"Cancelled Orders"}
        date={filter}
        data={pdfCancelledOrders}
        report={"cancelled"}
        header={[
          "Order No",
          "Added On",
          "Cancelled On",
          "Attendant",
          "Approved By",
          "Total",
        ]}
      ></ExportPDF>
    );
  }

  function handlePDFSI() {
    return (
      <ExportPDF
        name={"Cancelled Invoice"}
        date={filterSI}
        data={pdfCancelledSI}
        header={headerSI}
        report={"cancelled"}
      >
        <Pdf
          targetRef={pdfCancelledSI ? ref : ref2}
          filename={"officialReceipt_" + formatDate(new Date()) + ".pdf"}
          style={{ height: "100%", width: "100%" }}
        >
          {({ toPdf }) => (
            <button
              className="category-new-export-btn w-100"
              onClick={handlePrintReportSI}
            >
              Export to PDFSI
            </button>
          )}
        </Pdf>
      </ExportPDF>
    );
    //   }
    // }
  }

  const handleTabSelect = (tabKey) => {
    setChooseExportCSV(tabKey);
  };

  const divId = useRef(null);

  const handleGeneratePrint = () => {
    if (divId.current) {
      const element = divId.current;

      // element.style.width = "36%";
      // element.style.height = "100%"
      html2canvas(element, { scale: 1 }).then((canvas) => {
        canvas.toBlob((blob) => {
          new imageCompression(blob, {
            quality: 0.6,
            maxWidth: 2024,
            // maxHeight: 1024,
            success(compressedResult) {
              const reader = new FileReader();
              reader.readAsDataURL(compressedResult);
              reader.onloadend = () => {
                const compressedBase64 = reader.result;
                printBase64Data(compressedBase64);
                toast.success("Processing...", {
                  style: toastStyle(),
                });
              };
            },
          });
        }, "image/pngs");
      });
    }
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name,
      image,
      "0",
      // getRestoLogin()
    );
    if (response.data) {
      refreshPage();
    } else {
    }
  }

  useEffect(() => {
    fetchCancelledOrders();
  }, [filter]);

  useEffect(() => {
    fetchCancelledSI();
  }, [filterSI]);

  const marginTop = "-800px";
  const marginRight = "60px";
  const marginBottom = "-1000px";
  const marginLeft = "45px";
  const getPageMargins = () => {
    return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;}`;
  };

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"} //Dashboard navbar index
        page={"Reports"}
      />
      <div
        className={`container ps-5 pt-4 bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col lg={6}>
            <h1 className="page-title-menu"> CANCELLED REPORT </h1>
          </Col>
          {chooseExportCSV === "Cancelled SI" && (
            <Col lg={6}>
              <Row className="d-flex justify-content-end">
                <Col xs={4} className="d-flex justify-content-end">
                  <button
                    className="category-new-export-btn w-100"
                    onClick={handleGeneratePrint}
                  >
                    PRINT
                  </button>
                </Col>
                <Col xs={4}>{handleToCSVSI()}</Col>
                {(getRole() === "1" || getRole() === "7") && readyExportSI && (
                  <Col xs={4}>
                    <div className="d-flex justify-content-end">
                      {handlePDFSI()}
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          )}
          {chooseExportCSV === "Cancelled ORDERS" && (
            <Col lg={6}>
              <Row className="d-flex justify-content-end">
                <Col xs={4}>
                  <div className="d-flex justify-content-end">
                    <button
                      className="category-new-export-btn"
                      onClick={handleGeneratePrint}
                    >
                      PRINT
                    </button>
                  </div>
                </Col>
                <Col xs={4}>
                  {handleToCSV()}
                  {/* </div> */}
                </Col>
                <Col xs={4}>
                  <div className="d-flex justify-content-end">
                    {handlePDF()}
                  </div>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
        <hr />
        <Row>
          <Tabs
            defaultActiveKey="Cancelled SI"
            transition={false}
            id="noanim-tab-example"
            className="tabs-order-update"
            onSelect={handleTabSelect}
          >
            <Tab eventKey="Cancelled SI" title="Cancelled SI">
              <div className="mb-3">
                <div className="my-2 px-4 PO-filters d-flex">
                  {getRole() !== 2 && (
                    <>
                      {/* <span className="me-1 align-middle mt-2">Filter</span>
                      <span className="me-1 align-middle mt-2">By</span>
                      <span className="me-3 align-middle mt-2">Date:</span> */}
                      <span className="me-4 align-middle mt-2"> From:</span>
                      <Form.Control
                        size="sm"
                        type="date"
                        name="date_from"
                        className="date-filter me-3"
                        onChange={handleFilterSI}
                        value={filterSI.date_from}
                      />
                      <span className="me-4 align-middle mt-2">To:</span>
                      <Form.Control
                        size="sm"
                        type="date"
                        name="date_to"
                        className="date-filter me-3"
                        onChange={handleFilterSI}
                        value={filterSI.date_to}
                      />
                    </>
                  )}
                </div>
                {/* TABLE */}
                <Table
                  tableHeaders={[
                    "Invoice No.",
                    "Added On",
                    "Cancelled On",
                    "Approved By",
                    "Subtotal",
                    "Vat Sales",
                    "Vat Exempt Sales",
                    "Zero Rated",
                    "Total Sales",
                    "Total Vat",
                    "Total Discount",
                    "Vat Exemption",
                    "Total Amount",
                  ]}
                  headerSelector={[
                    "id",
                    "added_on",
                    "updated_on",
                    "approved_by",
                    "subtotal",
                    "vat_sales",
                    "vat_exempt",
                    "zero_rated",
                    "total_sales",
                    "vat_amount",
                    "discount",
                    "vat_exemption",
                    "total_amount",
                  ]}
                  tableData={cancelledSI}
                  showLoader={showLoader}
                />
              </div>
            </Tab>
            <Tab eventKey="Cancelled ORDERS" title="Cancelled ORDERS">
              <div className="mb-3">
                <div className="my-2 px-4 PO-filters d-flex">
                  {getRole() !== 2 && (
                    <>
                      {/* <span className="me-1 align-middle mt-2">FILTER</span>
                      <span className="me-2 align-middle mt-2">BY</span>
                      <span className="me-4 align-middle mt-2">DATE:</span> */}
                      <span className="me-4 align-middle mt-2">FROM:</span>
                      <Form.Control
                        size="sm"
                        type="date"
                        name="date_from"
                        className="date-filter me-3"
                        onChange={handleFilter}
                        value={filter.date_from}
                      />
                      <span className="me-4 align-middle mt-2">TO:</span>
                      <Form.Control
                        size="sm"
                        type="date"
                        name="date_to"
                        className="date-filter me-3"
                        onChange={handleFilter}
                        value={filter.date_to}
                      />
                    </>
                  )}
                </div>
                {/* TABLE */}
                <Table
                  tableHeaders={[
                    "Order No.",
                    "Added On",
                    "Cancelled On",
                    "Attendant",
                    "Approved By",
                    "Total",
                  ]}
                  headerSelector={[
                    "id",
                    "added_on",
                    "updated_on",
                    "attendant",
                    "approved_by",
                    "grand_total",
                  ]}
                  tableData={cancelledOrders}
                  showLoader={showLoader}
                />
              </div>
            </Tab>
          </Tabs>
        </Row>

{/* CSV COMPONENT */}
        <div style={{ display: "none" }}>
          <Row>
            <div className="row" ref={componentRef}>
              <Row>
                <Col className="d-flex justify-content-center print-text">
                  <label>{window.company_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_address}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_min}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_sn}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_ptu_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center print-text">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <table className="table table-bordered left ms-5 ">
                <thead></thead>
                <tbody>
                  <tr>
                    <th colSpan={3}>CANCELLED ORDERS REPORT</th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE FROM: {dateFormat(new Date(filter.date_from))}
                    </th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE TO: {dateFormat(new Date(filter.date_to))}
                    </th>
                  </tr>
                  <tr>
                    <th>ORDER NO.</th>
                    <th>DATE ADDED</th>
                    <th>DATE CANCELLED</th>
                    <th>ATTENDANT</th>
                    <th>APPROVED BY</th>
                    <th>TOTAL</th>
                  </tr>
                  {cancelledOrders.map((data) => {
                    return (
                      <tr>
                        <td>{data.id} </td>
                        <td>{data.added_on}</td>
                        <td>{data.updated_on}</td>
                        <td>{data.attendant}</td>
                        <td>{data.approved_by}</td>
                        <td>
                          {numberFormat(
                            parseFloat(data.grand_total).toFixed(2)
                          )}{" "}
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <br></br>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    {/* <td > {numberFormat(parseFloat(priceTotal).toFixed(2))}</td>
                                    <td > {numberFormat(parseFloat(grandTotal).toFixed(2))}</td> */}
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </Row>
        </div>
{/* PRINT COMPONENT */}
        <div className="hide-from-screen">
          <Row>
            <div className="row" ref={componentRefSI}>
              <Row>
                <Col className="d-flex justify-content-center print-text">
                  <label>{window.company_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_address}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_min}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_sn}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center  print-text">
                  <label>{window.company_ptu_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center print-text">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <table className="table table-bordered left ms-5 ">
                <thead></thead>
                <tbody>
                  <tr>
                    <th colSpan={3}>CANCELLED INVOICES REPORT</th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE FROM: {dateFormat(new Date(filter.date_from))}
                    </th>
                  </tr>
                  <tr>
                    <th colSpan={3}>
                      DATE TO: {dateFormat(new Date(filter.date_to))}
                    </th>
                  </tr>
                  <tr>
                    <th>Invoice No.</th>
                    <th>SI Date</th>
                    <th>Date Cancelled</th>
                    <th>APPROVED BY</th>
                    <th>Subtotal</th>
                    <th>Vat Sales</th>
                    <th>Vat Exempt Sales</th>
                    <th>Zero Rated</th>
                    <th>Total Sales</th>
                    <th>Total Vat</th>
                    <th>Total Discount</th>
                    <th>Vat Exemption</th>
                    <th>Total Amount</th>
                  </tr>
                  {cancelledSI.map((data) => {
                    return (
                      <tr>
                        <td>{data.id} </td>
                        <td>{data.added_on}</td>
                        <td>{data.updated_on}</td>
                        <td>{data.approved_by}</td>
                        <td>
                          {numberFormat(parseFloat(data.subtotal).toFixed(2))}
                        </td>
                        <td>
                          {numberFormat(parseFloat(data.vat_sales).toFixed(2))}
                        </td>
                        <td>
                          {numberFormat(parseFloat(data.vat_exempt).toFixed(2))}
                        </td>
                        <td>
                          {numberFormat(parseFloat(data.zero_rated).toFixed(2))}
                        </td>
                        <td>
                          {numberFormat(
                            parseFloat(data.total_sales).toFixed(2)
                          )}
                        </td>
                        <td>
                          {numberFormat(parseFloat(data.vat_amount).toFixed(2))}
                        </td>
                        <td>
                          {numberFormat(parseFloat(data.discount).toFixed(2))}
                        </td>
                        <td>
                          {numberFormat(
                            parseFloat(data.vat_exemption).toFixed(2)
                          )}
                        </td>
                        <td>
                          {numberFormat(
                            parseFloat(data.total_amount).toFixed(2)
                          )}{" "}
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <br></br>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td> {numberFormat(parseFloat(subtotal).toFixed(2))}</td>
                    <td> {numberFormat(parseFloat(vatSales).toFixed(2))}</td>
                    <td> {numberFormat(parseFloat(vatExempt).toFixed(2))}</td>
                    <td> {numberFormat(parseFloat(zeroRated).toFixed(2))}</td>
                    <td> {numberFormat(parseFloat(totalSales).toFixed(2))}</td>
                    <td> {numberFormat(parseFloat(vatAmount).toFixed(2))}</td>
                    <td> {numberFormat(parseFloat(discount).toFixed(2))}</td>
                    <td>
                      {" "}
                      {numberFormat(parseFloat(vatExemption).toFixed(2))}
                    </td>
                    <td> {numberFormat(parseFloat(totalAmount).toFixed(2))}</td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </Row>
        </div>
      </div>

      <div className="hide-from-screen">
        <div ref={divId}>
          <div className="d-flex-justify-content-center">
            <style>{getPageMargins()}</style>
            <div className="print-area single-width rounded p-4">
              <Row className="text-center print-text">
                {window.company_name}
              </Row>
              <Row className="text-center print-text">
                {window.company_address}
              </Row>
              <Row className="text-center print-text">
                {window.company_vat_reg_tin}
              </Row>
              <Row className="text-center print-text">{window.company_min}</Row>
              <Row className="text-center print-text">{window.company_sn}</Row>
              <Row className="text-center print-text">
                {window.company_ptu_no}
              </Row>
              <Row className="text-center print-text">
                {window.company_issued_date}
              </Row>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td colSpan={2} className="print-text">
                      <strong>
                        {chooseExportCSV === "Cancelled SI"
                          ? " CANCELLED SI REPORT"
                          : " CANCELLED ORDERS REPORT"}
                      </strong>
                    </td>
                  </tr>
                  {setChooseExportCSV === "Cancelled SI" ? (
                    <tr>
                      <td colSpan={2} className="print-text">
                        {/* Payment Report Cash <br /> */}
                        {moment(filterSI.date_from).format(
                          "MMMM DD, YYYY"
                        )} - {moment(filterSI.date_to).format("MMMM DD, YYYY")}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={2} className="print-text">
                        {/* Payment Report Cash <br /> */}
                        {moment(filter.date_from).format(
                          "MMMM DD, YYYY"
                        )} - {moment(filter.date_to).format("MMMM DD, YYYY")}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="print-text">
                      {chooseExportCSV === "Cancelled SI"
                        ? "Invoice No."
                        : "ORDER NO."}
                    </td>
                    <td className="print-text">AMOUNT</td>
                  </tr>
                  {chooseExportCSV === "Cancelled SI" &&
                    cancelledSI.map((row) => {
                      return (
                        <tr>
                          <td className="print-text">{row.trans_id}</td>
                          <td className="print-text">
                            {numberWithCommas(row.total_amount)}
                          </td>
                        </tr>
                      );
                    })}
                  {chooseExportCSV === "Cancelled ORDERS" &&
                    cancelledOrders.map((row) => {
                      return (
                        <tr>
                          <td className="print-text">{row.id}</td>
                          <td className="print-text">
                            {numberWithCommas(row.grand_total)}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <MytFooter/>
    </div>
  );
}

export default CancelledSI;
